var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCollapseIcon = function SvgCollapseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currnetColor",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.28 11.372H5.746c-.172 0-.312-.231-.312-.516 0-.286.14-.517.312-.517h15.536c.172 0 .312.231.312.517 0 .285-.14.516-.312.516Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.194 15.714a.396.396 0 0 1-.262-.102L5.61 11.27a.551.551 0 0 1-.177-.414c0-.164.066-.318.177-.415l5.23-4.339c.196-.17.471-.123.616.106.145.23.104.553-.09.723L6.61 10.856l4.846 3.927c.195.17.236.494.09.723a.42.42 0 0 1-.352.208Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.8,
    d: "M3.996 3.4v15.57"
  })));
};
export default SvgCollapseIcon;